import { createStyles, Theme } from '@material-ui/core/styles'

export default (theme: Theme) =>
	createStyles({
		container: {
			display: 'flex',
			flexDirection: 'column',
			marginTop: 16,
			marginBottom: '32px',
		},
		paper: {
			display: 'flex',
			flexDirection: 'row',
			padding: '24px',
			margin: '16px 0px 16px',
			[theme.breakpoints.down('md')]: {
				padding: 8,
			},
		},
	})
